import { TailwindThemeName } from '../../constants/common';

export enum CdsToastType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Default = 'default',
}

export const CdsToastTypeColorMap = {
  [CdsToastType.Success]: TailwindThemeName.Emerald,
  [CdsToastType.Error]: TailwindThemeName.Rose,
  [CdsToastType.Warning]: TailwindThemeName.Amber,
  [CdsToastType.Default]: TailwindThemeName.Cyan,
};

export type CdsToastProps = {
  buttonText?: string;
  buttonOnClick?: () => void;
  toastId?: string;
  showLoader?: boolean;
  closeButton?: boolean;
};

export type CdsToastOptions = {
  message: string;
  type?: CdsToastType;
  onClose?: () => void;
} & CdsToastProps;

export type CdsToastUpdateProps = {
  message: string;
  type?: CdsToastType;
} & Omit<CdsToastProps, 'toastId'>;
